import React from 'react'
import { Grid } from '@mui/material'
import BenefitsPanel from '../components/benefits-panel'
import StepHeader from '../components/step-header'
import StepPageContainer from '../components/step-page-container'

const DetailsPage = ({ rightPanel }) => {
  return (
    <StepPageContainer>
      <Grid item xs={12}>
        <StepHeader />
      </Grid>
      <Grid item xs={12} sm={rightPanel ? 5 : 7}>
        <BenefitsPanel />
      </Grid>
      {rightPanel && (
        <Grid item xs={12} sm={7}>
          {rightPanel}
        </Grid>
      )}
    </StepPageContainer>
  )
}

export default DetailsPage
